import axios from 'axios';

export interface SlotRangeFilter {
  startAt: string;
  endAt: string;
}

export const slotApi = {
  fetchSlots: async (url: string, filter?: SlotRangeFilter) => {
    const response = await axios.get(url, filter ? { params: { filter } } : undefined);
    return response.data;
  },
};
